import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.object.freeze.js";
import "core-js/modules/es.object.define-properties.js";
var _templateObject;
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
import styled from 'styled-components';
import { maxMediaQueries } from '@finect/tabular-utils/mediaQueries';
import { hideScrollbar } from '@finect/tabular-utils/hideScrollbar';
import { animation } from './animation';
export var ModalBox = styled.div.withConfig({
  displayName: "ModalBox",
  componentId: "sc-1j0lgi0-0"
})(["display:flex;position:fixed;z-index:10000000;align-items:center;flex-direction:row;justify-content:center;overflow:auto;-webkit-overflow-scrolling:touch;width:100%;height:100%;padding:0;", ";", " ", ";"], animation, hideScrollbar, maxMediaQueries.phone(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    width: 100%;\n    height: 100%;\n    padding: 0;\n  "]))));